import React, { useState } from 'react'

import './ViewMenu.scoped.sass'

export function ViewMenu (props) {
  const { options = [] } = props
  const [selectedView, setSeletedView] = useState(options.find(opt => opt.active)?.label || '')
  const isActiveClass = (view) => selectedView === view ? 'active' : ''

  const onOptionSelected = (option) => {
    const { label, action } = option
    setSeletedView(label)
    if (action) action()
  }

  return <menu className="view-buttons">
    {options.map((option, index) =>
      <li key={index} className={`${isActiveClass(option?.label)}`} onClick={() => onOptionSelected(option)}>
        {option.icon}
      </li>)}
  </menu>
}
